import ScrollHint from 'scroll-hint';
import 'scroll-hint/css/scroll-hint.css';

export const Scrollable = {
  init() {
    const scrollables = document.querySelectorAll('.js-scrollable');
    if (scrollables.length) {
      new ScrollHint('.js-scrollable', {
        scrollHintIconAppendClass: 'scroll-hint-icon-white',
        applyToParents: false,
        i18n: {
          scrollable: 'スクロールできます',
        },
      });
    }
    const simplebars = document.querySelectorAll('.c-simplebar02.-has-scrollable');
    if (simplebars.length) {
      simplebars.forEach((el) => {
        const content = el.querySelector('.simplebar-content');
        new ScrollHint(content, {
          scrollHintIconAppendClass: 'scroll-hint-icon-white',
          applyToParents: true,
          i18n: {
            scrollable: 'スクロールできます',
          },
        });
      });
    }
  },
};
